module.exports = __webpack_public_path__ + "img/embaixo8.7c6888b9.jpg";